import React from "react";

import { mdiInformationOutline } from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import type { JSX } from "react";
import type { HeaderProps } from "react-big-calendar";

export function MonthHeader({ label }: HeaderProps): JSX.Element {
  return (
    <div className="p-[0.15625rem]">
      <div className="text-foreground capitalize">{label}</div>
    </div>
  );
}

interface WeekHeaderProps extends HeaderProps {
  onClick: (date: Date) => void;
}

export function WeekHeader({ date, onClick }: WeekHeaderProps): JSX.Element {
  const dayOfWeek = moment(date).format("dddd");
  const day = moment(date).format("DD");

  const handleClick = (event: React.MouseEvent): void => {
    event.stopPropagation();
    onClick(date);
  };

  return (
    <div
      className="flex h-[70px] cursor-pointer flex-col items-center justify-center p-[0.15625rem]"
      onClick={handleClick}
    >
      <div className="text-foreground font-medium capitalize">{dayOfWeek}</div>
      <div className="text-[2.34375rem]">{day}</div>
    </div>
  );
}

export function TimeGutterHeader(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  return (
    <div
      className="flex size-full items-center justify-center"
      data-tooltip-content={t("calendarTimeGutterTooltip")}
      data-tooltip-id="calendar-date-cell"
    >
      <Icon path={mdiInformationOutline} size={0.9375} />
    </div>
  );
}
